import { makeStyles, Button, Avatar } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    button: {
        backgroundColor: "#fff",
        height: theme.spacing(5),
        '&:hover': {
            background: "#fff",
            boxShadow: "0 0 6px #4285f4"
        },
    },
    small: {
        width: theme.spacing(2),
        height: theme.spacing(2),
    },
    
}));
const GoogleButton = (props) => {
    const classes = useStyles();
    return (
        <Button
            variant="outlined"
            color="default"
            startIcon={<Avatar src={'https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg'} className={classes.small} />}
            style={{textTransform: 'capitalize'}}
            className={classes.button}
            // NOTE:
            // 即時関数を使わないなら、methodはBindさせないとクラス内のメソッドとして認識してくれない,
            // そのBindの一方法が即時関数での書き方というわけ、即時関数では無いとその関数がレンダー時にUndefiedとなりエラーが出力してしまう
            // 子コンポーネントは親からの引数をonClickにぶっこんでるだけ
            onClick={props.onGoogleButoonClick}
        >
        Sign in with Google
      </Button>
    )
}

export default GoogleButton;